window.SmoothScrollOptions = { 
    animationTime       : 1500,
    accelerationDelta   : 20,  
    accelerationMax     : 1 
}
require('../../node_modules/smoothscroll-for-websites/SmoothScroll');
require('../../node_modules/simplelightbox/dist/simple-lightbox.min.js');

import { gsap }                 from "gsap";
import { ScrollTrigger }        from "gsap/ScrollTrigger";
import { ScrollToPlugin }       from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin); 

import * as Menu                from "./components/Menu";
import * as Search              from "./components/Search";


import * as Intros              from "./components/IntroPage";
import * as mask                from "./components/jqMask";
import * as ScrollEvents        from "./components/ScrollEvents";
import * as jqValidate          from "./components/JqValidate";
import * as Gallery             from "./components/Gallery";
import * as Svg                 from "./components/Svg";
import * as ModalVideo          from "./components/ModalVideo";
import * as AjaxLoadPage        from "./components/AjaxLoadPage";
import * as Grid                from "./components/Grid";
import * as SimpleLightbox      from "./components/SimpleLightBox";
import * as FormAjax 			from "./components/FormAjax";
import * as CustomDropdown		from "./components/CustomDropdown";
import * as CustomSwitch        from "./components/Switch";
import * as ToggleDescriptions  from "./components/ToggleDescriptions";
import * as CustomModal         from "./components/CustomModal";
import * as Lgpd                from "./components/Lgpd";


// loader site
document.onreadystatechange = function () {
    //AjaxLoadPage.init(1);
    jqValidate.formAjax();
    if (document.readyState == "complete") {
        app();
    }
}

const app = () => {
    AjaxLoadPage.init(0);
    Menu.init();
    update();
}

window.update = () =>{
    Search.init();
    Intros.init();
    mask.inputsMask();
    FormAjax.init();
    Grid.init();
    ScrollEvents.init();
    CustomDropdown.init();
    CustomSwitch.init();
    ToggleDescriptions.init();
    Gallery.init();
    jqValidate.formAjax();
    CustomModal.init();
    ModalVideo.init(); 
    //Lgpd.init();  
    // SimpleLightbox.init(); 
    setTimeout(()=>{
        Svg.init();
    },500)


}

$(document).on('submit', '.up-integration', function(){

    Swal.fire({
        title: 'Por favor, Aguarde...',
        allowOutsideClick: false,
        showCancelButton: false,
        showCloseButton: false,
        didOpen: () => {
            Swal.showLoading()
        }
    });

    const button = $(this).find('button');
    button.attr('disabled', 'disabled');
    button.html('<p>Enviando...</p>');

});

// this function this respost of success of .js "up-integration"
window.callbackIntegrationOne = function(form,status, response) {

    const button = form.find('button');

/*     console.log('chamou integration war');
    console.log('status: ' + status); */
    
    Swal.close();

    Swal.fire({
        icon: status != false ? 'success' : 'error',
        title: status == true ? 'Enviado com sucesso!' : 'Ocorreu um erro...',
        showConfirmButton: false,
        timer: 3000
    })

    button.removeAttr('disabled');
    button.html('<p>Enviar</p>');
    form.trigger("reset");    
    
    //if (status == true) {
        //if( form.find('input[name=tag-google-aw]').length > 0 ) {
/*                 let valConvertion = $('input[name=tag-google-aw]').val();
            gtag('event', 'conversion', {'send_to': valConvertion});
            console.log("success convertion = " + valConvertion);
            console.log(response)
            gtag('event', 'send-api-integration-one', {
                'app_name': 'hydepark',
                'opportunity_id': response.opportunity_id
            }); */
       // }
    //}
}